import { AlertCircle, CheckCircle2, Clock, Loader } from 'lucide-react';

// The four register counts, over the caller's scope (every intake for
// holders of intake:read_all, their own otherwise), whatever tab or filter
// is active. Definitions: backend/routes/intake_review.py, _indicators.
const CARDS = [
  { key: 'awaiting_approval', label: 'Awaiting approval', icon: Clock, color: '#f59e0b' },
  { key: 'action_needed', label: 'Action needed', icon: AlertCircle, color: '#ef4444' },
  { key: 'in_progress', label: 'In progress', icon: Loader, color: '#2d9cdb' },
  { key: 'done_last_30_days', label: 'Done in the last 30 days', icon: CheckCircle2, color: '#10b981' },
];

export default function IndicatorRow({ counts }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="intake-indicators">
      {CARDS.map(({ key, label, icon: Icon, color }) => (
        <div
          key={key}
          className="bg-white dark:bg-white/5 border border-[#e3e3e3] dark:border-white/10 p-6"
          data-testid={`intake-indicator-${key}`}
        >
          <div className="flex items-center justify-between mb-4">
            <span className="text-sm font-medium text-[#30302F] dark:text-white">{label}</span>
            <Icon size={18} strokeWidth={1.5} style={{ color }} aria-hidden="true" />
          </div>
          <div className="text-3xl font-heading text-[#30302F] dark:text-white">
            {counts ? counts[key] ?? 0 : '-'}
          </div>
        </div>
      ))}
    </div>
  );
}
